// https://stackoverflow.com/a/2998874/1673761
export const twoDigits = (num:number):string => String(num).padStart(2, '0')
